module.exports = __webpack_public_path__ + "img/P3.0be70124.jpg";